import React from "react";
import * as PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import classnames from "classnames";
import styleConstants from "../../../../styleConstants";
import "./source.scss";

const useStyles = makeStyles(theme => ({
  path: {
    fill: "none",
    strokeWidth: 3,
    opacity: 1.0,
    stroke: styleConstants.colors.gray3,
    transition: "opacity 0.3s ease-in-out"
  }
}));

const Connection = props => {
  const classes = useStyles();

  return (
    <path
      id={props.id}
      d={props.d}
      className={classnames(
        props.groups,
        classes.path,
        props.current === undefined
          ? undefined
          : props.groups.includes(props.current)
          ? "active"
          : "faded"
      )}
    />
  );
};

Connection.propTypes = {
  id: PropTypes.string.isRequired,
  d: PropTypes.string.isRequired,
  groups: PropTypes.arrayOf(PropTypes.string)
};

export default Connection;
